import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../axiosInstance';

// Define an async thunk to fetch data from the API

export const userSignupApi = createAsyncThunk(
    'login/userSignupApi',
    async (formData, { rejectWithValue }) => { // Accept email and password as arguments
      try {
        const response = await axiosInstance.post('/auth/register/'
          ,formData);
        return response.data;  
      } catch (error) {
        return rejectWithValue(error.response ? error.response.data : error.message);
      }
    }
  );

  export const fetchUserType = createAsyncThunk(
    'usertype/fetchUserType',
    async (formData, { rejectWithValue }) => { // Accept email and password as arguments
      try {
        const response = await axiosInstance.get('/auth/getroles/');
        return response.data;  
      } catch (error) {
        return rejectWithValue(error.response ? error.response.data : error.message);
      }
    }
  );
  


 